﻿import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
    name: 'stateconverter',
    pure: true
})
@Injectable()
export class StateConverterPipe implements PipeTransform {
    transform(state: string): any {

        if (state === "approved") {
            return "Turen er færdig og godkendt";
        } else if (state === "approvedautocompleted") {
            return "Turen er færdig, godkendt, og autogodkendt i slammanager";
        }
        else if (state === "started") {
            return "Turen er startet af chaufføren";
        }
        else if (state === "completed") {
            return "Turen er færdig fra chaufføren, men mangler godkendelse";
        }
        
        return state;

    }
}